/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { Navigate, useParams } from 'react-router';

/* Import configuration */
import { APP_ROUTES } from '@/config/appRoutes';
import { OVERVIEW_ANOMALY_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import AnomalyMetricsOverview from '@/components/tabs/overview/metrics/AnomalyMetricsOverview';

function ClientDetailTab() {
    const { clientKey } = useParams<{ clientKey: string }>();

    if (!clientKey) {
        return <Navigate to={APP_ROUTES.clients} replace />;
    }

    return (
        <AnomalyMetricsOverview
            anomalyConfigs={OVERVIEW_ANOMALY_CONFIGS}
            description="Overview of all available anomaly metrics."
            fixedCustomer={clientKey}
            heading={clientKey}
            idPrefix="customer-detail"
        />
    );
}

export default ClientDetailTab;
